import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 8h1v8","key":"svg-0"}],["path",{"d":"M7 8h4l-2 8","key":"svg-1"}]]

const IconNumber71Small = createReactComponent('outline', 'number-71-small', 'Number71Small', __iconNode);

export default IconNumber71Small;